/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - System</b>: Системные сообщения</li>\n<li><b>2 - Feedback</b>: Обратная связь</li>\n<li><b>3 - Radio</b>: Радио</li>\n</ul>\n
 */
export const chatTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - System</b>: Системные сообщения</li>\n<li><b>2 - Feedback</b>: Обратная связь</li>\n<li><b>3 - Radio</b>: Радио</li>\n</ul>\n")